import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../mock/mock';
import BracketButton from './BracketButton';

const Services = () => {
  return (
    <section id="services" className="relative bg-white py-28 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-[1.5px] bg-black/60" />
              <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-black/60">
                What We Move
              </span>
            </div>
            <h2 className="big-display text-[54px] sm:text-[72px] lg:text-[96px] leading-[0.9]">
              Specialized Services
              <br />
              <span className="text-black/30">Designed For Speed and Safety.</span>
            </h2>
          </div>
          <BracketButton to="/services" variant="dark">All Services</BracketButton>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 border border-black/10">
          {services.map((s) => (
            <a
              key={s.id}
              href={`/services#${s.id}`}
              className="group relative bg-white overflow-hidden aspect-[4/3] block"
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10 group-hover:from-black/70 transition-colors duration-500" />
              <div className="absolute inset-0 p-8 lg:p-10 flex flex-col justify-between text-white">
                <div className="flex items-start justify-between">
                  <span className="font-mono-tech text-[11px] tracking-[0.3em]">{s.number}</span>
                  <ArrowUpRight className="w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div>
                  <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/70 mb-3">
                    {s.short}
                  </div>
                  <h3 className="big-display text-[38px] sm:text-[48px] leading-[0.95] mb-3">
                    {s.title}
                  </h3>
                  <p className="font-body text-sm text-white/85 max-w-md leading-relaxed opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500 max-h-0 group-hover:max-h-40 overflow-hidden">
                    {s.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
